var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"toggle-buttons"},[_c('b-form-radio-group',{attrs:{"id":'button-radios-'+_vm.id,"options":_vm.options,"name":'radios-btn-'+_vm.facetTitle,"button-variant":"madeleine","buttons":""},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }